import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getPostCategory } from "../../../../graphql/queries";
import { updatePostCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as PostCategoriesConstants from "../../../../graphql/Constants/PostCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";

const PostCategoryEdit = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateButtonDisableStatus, setUpdateButtonDisableStatus] = useState(
    false
  );

  //#region update PostCategory business logic
  const handleUpdatePostCategory = async () => {
    try {
      // initial required PostCategory update data
      let input = {
        id: props.match.params.postCategoryId,
        name: name.trim(),
        order: order
      };

      await API.graphql(graphqlOperation(updatePostCategory, { input }));
      return { result: true, message: `PostCategory updated successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error updating PostCategory, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Edit}
      returnHandler={() => props.history.push(`/postCategories`)}
      modelName="Post Category"
      getModelMethod={async () => {
        let result = await API.graphql(
          graphqlOperation(getPostCategory, { id: props.match.params.postCategoryId })
        );
        if (result) {
          setName(result.data.getPostCategory.name);
          setOrder(result.data.getPostCategory.order);
        }
        return result.data.getPostCategory;
      }}
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === PostCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleUpdatePostCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "PostCategory",
          false, // we need to exclude the OTHER
          setUpdateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={updateButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Post Category Name"
        placeholder="Enter a Post Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "PostCategory",
            false, // we need to exclude the OTHER,
            setName,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Post Category Order"
        placeholder="Enter a Post Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "PostCategory",
            setOrder,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default PostCategoryEdit;
